import store from './../store/index.js'
import axios from 'axios'
import {
	Toast
} from 'vant';
const baseURL = process.env.NODE_ENV === 'production' ? 'http://customer.medsci.cn' : '/api';

// 请求拦截器
let requestTime = 0;
axios.interceptors.request.use(function (config) {
	requestTime = 0;
	setTimeout(function () {
		if (requestTime > 1500) {
			// 判断ajax请求时间
			store.dispatch('showLoading');
		}
	}, 1500);
	return config;
})
// 响应拦截器
axios.interceptors.response.use(function (response) {
	requestTime = 1500;
	store.dispatch('closeLoading');
	return response;
})

export default function apiAxios(method, url, params) {
	let httpDefault = {
		method: method,
		baseURL: baseURL,
		url: url,
		// `params` 是即将与请求一起发送的 URL 参数
		// `data` 是作为请求主体被发送的数据
		params: method === 'GET' || method === 'DELETE' ? params : null,
		data: method === 'POST' || method === 'PUT' ? params : null,
		timeout: 10000,
		headers: {
			token: ""
		}
	}
	// 注意**Promise**使用(Promise首字母大写)
	return new Promise((resolve, reject) => {
		axios(httpDefault)
			// 此处的.then属于axios
			.then(res => {
				if (res.data && [200, 0].indexOf(res.data.error_code) == -1 && res.data.msg) {
					Toast.fail({
						message: res.data.msg,
						forbidClick: true
					});
					setTimeout(function () {
						reject(res)
					}, 2000)
				} else {
					resolve(res)
				}
			}).catch(response => {
				// errorState(response)
				reject(response)
			})
	})
}